Ext.define('SA.lq.view.SearchController', {
    constructor({gridSizer, queryFactory, resultsHeader, grid}) {
        this.gridSizer = gridSizer;
        this.queryFactory = queryFactory;
        this.resultsHeader = resultsHeader;
        this.grid = grid;
    },

    applyLocationAliasChange({locationSeries, alias}) {
        var gridData = structuredClone(this.grid.getData()),
            rowData = gridData.find(rowData => rowData.locationInfo.locationSeries === locationSeries);

        if (!rowData) {
            return;
        }

        rowData.locationInfo.alias = alias;
        rowData.name = Ext.util.Format.locationRenderer({name: rowData.locationInfo.name, locationAlias: alias});

        this.grid.setData(gridData);
    },

    cancelQuery() {
        this.query?.cancel();
    },

    onQuerySuccess(result) {
        this.resultsHeader.displayResultCountText({count: result.getResultCount(), geoUnit: result.getGeoUnit()});

        this.grid.setVisible(result.hasData());
        this.grid.setLoading(false);
        this.grid.setColumns(result.getColumnCfgs());
        this.grid.setData(result.mapData(mapRecordToRow));
        this.gridSizer.resize();

        function mapRecordToRow({locationInfo, rank, ...attributes}) {
            var name = Ext.util.Format.locationRenderer({name: locationInfo.name, locationAlias: SA.data.LocationAliases.get(locationInfo.locationSeries)}),
                formatAttributeValue = ({attributeId, value}) => SA.data.AttributesCache.getFormatter(attributeId).format(value),
                attributes = SA.Object.mapValues(attributes, (value, attributeId) => formatAttributeValue({attributeId, value}));

            return {locationInfo, rank, name, ...attributes};
        }
    },

    onSearchIntent(state) {
        this.cancelQuery();

        this.query = this.queryFactory.createQuery(state);
        this.query.run();

        this.resultsHeader.displayLoadingText();
        this.grid.setLoading(true);
    }
});